import React, { useEffect } from "react";
import Grid from "@mui/material/Grid2";
import { Button } from "react-bootstrap";





export default function ContactRibbon() {
  useEffect(() => {
    window.scrollTo(0, 0);
       document.title="Home"
  }, []);
  return (


  <Grid container size={{xs:12,sm:12,md:12,lg:12,xl:12}} justifyContent="center" backgroundColor='#117E76' color='white' padding='1% 0' className='contact-ribbon-container'  >

<Grid container size={12} justifyContent='center' > 
<h1>Contact Us</h1>
</Grid>

<Grid container size={12} justifyContent='center' > 
<p paddingBottom='0!important' >  Email: forwardfocus@alachuacounty.us</p>
</Grid>
<Grid container size={12} justifyContent='center'> 
<p paddingBottom='0!important'> Phone Number: 352-374-5204 </p>
</Grid>
<Grid container size={12} justifyContent='center' >
      <p className='sub-text'fontSize='10px'>Want to Subscribe to the Communication's Press Releases?</p>
   
    </Grid>
    <Grid>
      
  <Button 
     href="https://visitor.constantcontact.com/manage/optin?v=001LBos8BrBhyrMp-1MzvGUro3qLS0VNwDZ"   target="_blank"    className='alt-button' >
 
  SIGN UP
    </Button>
    </Grid>
    
{/*     <Grid container size={{xs:12, sm:10, md:12, lg:3, xl:3}} alignItems='center'  justifyContent='center' flexDirection='column'>
      <Grid container paddingBottom='2%'>
  <h3>Get In Touch</h3>
  </Grid>
  <Grid container size={12} alignContent='center'>
    <Grid size={1}>
<EmailIcon/>
</Grid>
<Grid container size={11} paddingBottom='4%'>
  <Grid container size={11}>
<h5>Email</h5>
</Grid>
<Grid container size={11}>
  <p>
  forwardfocus@alachuacounty.us
</p>
</Grid>
</Grid>
  </Grid>
  <Grid container size={12} alignContent='center'>
    <Grid size={1} >
<PhoneIcon/>
</Grid>
<Grid container size={11}>
  <Grid container size={11}>
<h5>Phone Number</h5>
</Grid>
<Grid container size={11}>
  <p>
  352-374-5204 
</p>
</Grid>
</Grid>
  </Grid>
    </Grid>
 */}
   {/* 
    <Grid container size={{xs:12, sm:12, md:12, lg:3, xl:3}} alignItems='center' justifyContent='start' flexDirection='column'>
      <Grid container paddingBottom='2%'>
  <h3>Stay Connected</h3>
  </Grid>
  <Grid container size={12} alignContent='center' justifyContent='center' spacing={1}>
<XIcon/>
<InstagramIcon />
<FacebookIcon />
  </Grid>
</Grid>
       */}
    
   
 
  </Grid>




  );
}